/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 11/21/17
 * Copyright All Rights Reserved
 */

import React from 'react';
import PropTypes from 'prop-types';
import BaseMap from 'components/maps/BaseMap';
import { change } from 'redux-form';

const SiteMapWithStaticMarker = ({ center, markers, dispatch }) => {
  if (markers.length === 0) {
    return null;
  }

  // Dispatch marker changes to the siteInfo form container
  const updatedMarkers = markers.map((marker) => {
    const newMarker = marker;
    newMarker.draggable = true;
    newMarker.onDragEnd = (props) => {
      dispatch(change('siteInfo', 'lat', `${props.latLng.lat().toFixed(7)}`));
      dispatch(change('siteInfo', 'lng', `${props.latLng.lng().toFixed(7)}`));
    };
    return newMarker;
  });

  return (
    <BaseMap
      center={center}
      markers={updatedMarkers}
      wrapperHeight={300}
      wrapperClassName="site-map-with-static-marker"
    />
  );
};

SiteMapWithStaticMarker.defaultProps = {
  center: { lat: 0, lng: 0 },
  markers: [],
};

SiteMapWithStaticMarker.propTypes = {
  // the map's center on render
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }).isRequired,
  // an array of objects, each of which contains data for a marker
  markers: PropTypes.arrayOf(
    PropTypes.object
  ).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default SiteMapWithStaticMarker;
